import { MortgageInterface } from '@app/interfaces/mortgage.interface';
import { ContractTermPeriodEnum } from '@app/enums/contract-term-period.enum';
import { ResidenceTypeEnum } from '@app/enums/residence-type.enum';
import { IncomeTypeEnum } from '@app/enums/income-type.enum';
import { IncomeLocationEnum } from '@app/enums/income-location.enum';
import { ExpenditureTypeEnum } from '@app/enums/expenditure-type.enum';

export class FillingScore750 {
    static check(mortgage: MortgageInterface): boolean {
        return !!(
            mortgage._contacts &&
            mortgage._contacts.every((a) => {
                if (a.nationality !== 'CZE') {
                    if (!a.residence || a.economicallyActivePeriod === undefined) {
                        return false;
                    }
                    const residence: ResidenceTypeEnum = ResidenceTypeEnum[a.residence];
                    if (
                        [ResidenceTypeEnum.temporary, ResidenceTypeEnum.long].includes(residence) &&
                        (!a.residenceFromDate || !a.residenceToDate)
                    ) {
                        return false;
                    }
                }
                return (
                    a.familyStatus &&
                    a.incomes &&
                    a.incomes.length &&
                    a.incomes.every((inc) => {
                        if (!inc.type) {
                            return false;
                        }
                        if (!inc.location) {
                            return false;
                        }
                        const incType: IncomeTypeEnum = IncomeTypeEnum[inc.type];
                        const incLocation: IncomeLocationEnum = IncomeLocationEnum[inc.location];
                        if (![IncomeTypeEnum.noIncome, IncomeTypeEnum.rentalIncome].includes(incType)) {
                            if (!inc.amount && inc.amount !== 0) {
                                return false;
                            }
                        }
                        if (
                            [IncomeLocationEnum.expat, IncomeLocationEnum.pendler].includes(incLocation) &&
                            (!inc.locationCountry || !inc.locationAccount || !inc.currency)
                        ) {
                            return false;
                        }
                        if (
                            [
                                IncomeTypeEnum.indefinitePeriodEmployment,
                                IncomeTypeEnum.indefiniteActionAgreement,
                                IncomeTypeEnum.indefiniteEmploymentAgreement,
                                IncomeTypeEnum.selfEmployment,
                                IncomeTypeEnum.parentalContribution,
                                IncomeTypeEnum.maternityContribution,
                                IncomeTypeEnum.fosterCareAllowance,
                            ].includes(incType) &&
                            !inc.fromDate
                        ) {
                            return false;
                        }
                        const incContractTermPeriod = ContractTermPeriodEnum[inc.contractTermPeriod];
                        if (
                            [
                                IncomeTypeEnum.rentalIncome,
                                IncomeTypeEnum.futureRentalRevenue,
                                IncomeTypeEnum.rentalIncomeOutsideTaxReturn,
                            ].includes(incType) &&
                            (!inc.fromDate ||
                                (incContractTermPeriod === ContractTermPeriodEnum.fixedTerm && !inc.untilDate))
                        ) {
                            return false;
                        }
                        if (
                            [
                                IncomeTypeEnum.fixedTermEmployment,
                                IncomeTypeEnum.employmentAgreement,
                                IncomeTypeEnum.actionAgreement,
                            ].includes(incType) &&
                            (!inc.fromDate || !inc.untilDate || inc.employmentExtendedCount === undefined)
                        ) {
                            return false;
                        }
                        if (
                            (incType === IncomeTypeEnum.fixedTermEmployment ||
                                incType === IncomeTypeEnum.indefinitePeriodEmployment ||
                                incType === IncomeTypeEnum.employmentAgreement ||
                                incType === IncomeTypeEnum.actionAgreement) &&
                            inc.employedAtOwnCompany === undefined
                        ) {
                            return false;
                        }
                        if (incType === IncomeTypeEnum.turnoverIncome && (!inc.source.name || !inc.source.idNumber)) {
                            return false;
                        }
                        if ([IncomeTypeEnum.diet].includes(incType)) {
                            if (!inc.professionType) {
                                return false;
                            }
                        }
                        if ([IncomeTypeEnum.selfEmployment].includes(incType)) {
                            if (inc.stoppedInLastTwoYears === undefined) {
                                return false;
                            }
                        }
                        return true;
                    }) &&
                    (!a.expenditures.length ||
                        a.expenditures.every((exp) => {
                            if (!exp.type) {
                                return false;
                            }
                            const expType: ExpenditureTypeEnum = ExpenditureTypeEnum[exp.type];
                            if (
                                [ExpenditureTypeEnum.overdraft, ExpenditureTypeEnum.creditCard].includes(expType) &&
                                !exp.limit
                            ) {
                                return false;
                            }
                            if (
                                [
                                    ExpenditureTypeEnum.consumerLoan,
                                    ExpenditureTypeEnum.mortgage,
                                    ExpenditureTypeEnum.buildingSavingsLoan,
                                    ExpenditureTypeEnum.alimony,
                                    ExpenditureTypeEnum.nonbankLoan,
                                    ExpenditureTypeEnum.leasing,
                                    ExpenditureTypeEnum.businessLoan,
                                ].includes(expType) &&
                                !exp.payment
                            ) {
                                return false;
                            }
                            if (
                                [
                                    ExpenditureTypeEnum.consumerLoan,
                                    ExpenditureTypeEnum.mortgage,
                                    ExpenditureTypeEnum.buildingSavingsLoan,
                                    ExpenditureTypeEnum.nonbankLoan,
                                    ExpenditureTypeEnum.leasing,
                                    ExpenditureTypeEnum.businessLoan,
                                ].includes(expType) &&
                                !exp.balance
                            ) {
                                return false;
                            }
                            if (expType === ExpenditureTypeEnum.other && !exp.limit && !exp.payment && !exp.balance) {
                                return false;
                            }
                            return true;
                        }))
                );
            })
        );
    }
}
